import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { titleCase } from '../util/formatters';
export const InfoField = ({ label, value, mono, titleCaseValue }) => {
    const raw = value === undefined || value === null || value === ''
        ? '—'
        : typeof value === 'number'
            ? value.toString()
            : value;
    const display = titleCaseValue && raw !== '—' ? titleCase(raw) : raw;
    return (_jsxs("div", { children: [_jsx("div", { className: "text-xs opacity-70", children: titleCase(label) }), _jsx("div", { className: mono ? 'font-mono text-sm' : 'text-sm', children: display })] }));
};
